import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';
import { ClockLoader } from 'react-spinners';
import { ScheduleClassModal } from '../../components/schedule_class_modal'

function SubscriptionsScreen() {
  const navigate = useNavigate();
    const [cookies] = useCookies();
    const [subscriptions, setSubscriptions] = useState([]);
    const [privateSubscriptions, setPrivateSubscriptions] = useState([]);
    const [showScheduleModal, setShowScheduleModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const { setTostMessage } = useContext(TostMessageContext);
    const [paymentModalDetails, setPaymentModalDetails] = useState({});
    const {logOutFunction, calendarValues, setCalendarValues, userProfile} = useContext(UserContext);
    
    useEffect(() => {
        getClasses();
    }, []);

    const getClasses = async () => {
        setLoading(true);
        try {
            const response = await axios.get(base_url + '/subscription/view-subscriptions.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setLoading(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoading(false);
                if (response.data.subs?.length > 0 || response.data.private_subs?.length > 0) {
                    setSubscriptions(response.data.subs);
                    setPrivateSubscriptions(response.data.private_subs);
                }
            } else {
                setLoading(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='flex flex-col justify-between'>
                    {showScheduleModal && (
                        <ScheduleClassModal 
                            subscription_id={paymentModalDetails?.subscription_id} 
                            language_name={paymentModalDetails?.language_name}
                            level_name={paymentModalDetails?.level_name}
                            no_of_sessions={paymentModalDetails?.no_of_sessions}
                            tutor_avail={paymentModalDetails?.tutor_avail}
                            sessions_array={paymentModalDetails?.sessions_array}
                            loading={false} 
                            setShowScheduleModal={setShowScheduleModal}
                        />
                    )}
                    {loading ? (
                        <div className='flex justify-center items-center w-fill-available h-full z-[999999] bg-[#ffffff] opacity-[0.6] fixed top-0'>
                            <ClockLoader
                                color={'#F4D00F'}
                                loading={loading}
                                size={60}
                                aria-label="Loading Spinner"
                                data-testid="loader1"
                            />
                        </div>
                    ) : (
                    <>
                    <h2 className="text-xl font-semibold mb-6">Group Classes</h2>
                    <div className='overflow-x-auto'>
                    <table className="w-full table-auto border-collapse text-sm">
                        <thead className="bg-gray-50 border-b">
                        <tr>
                            <th className="p-4">
                                <div className="flex items-center gap-1">#</div>
                            </th>
                            <th className="text-left px-4 py-2 font-medium text-gray-600">
                                <div className="flex items-center gap-1">Child</div>
                            </th>
                            <th className="text-left px-4 py-2 font-medium text-gray-600">
                                <div className="flex items-center gap-1">Class</div>
                            </th>
                            <th className="text-left px-4 py-2 font-medium text-gray-600">
                                <div className="flex items-center gap-1">Amount</div>
                            </th>
                            <th className="text-left px-4 py-2 font-medium text-gray-600">
                                <div className="flex items-center gap-1">Expires At</div>
                            </th>
                            <th className="text-left px-4 py-2 font-medium text-gray-600">
                                <div className="flex items-center gap-1">Action</div>
                            </th>
                        </tr>
                        </thead>
                        <tbody className="text-gray-700">
                            {subscriptions?.map((row, index) => (
                                <tr
                                key={index}
                                className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                                >
                                    <td className="px-4 py-2">
                                        {++index}
                                    </td>
                                    <td className="px-4 py-2 font-semibold">
                                        {row.child_name}
                                    </td>
                                    <td className="px-4 py-2">
                                        {row.language} ({row.level})
                                    </td>
                                    <td className="px-4 py-2">
                                        {row.amount} {row.currency} / mo
                                    </td>
                                    <td className="px-4 py-2">
                                        {row.expiry}
                                    </td>
                                    <td className="px-4 py-2">
                                        <button className='px-4 py-2 bg-yellow rounded-[5px] text-dark'>Renew</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </div>
                    <h2 className="text-xl font-semibold mt-6 mb-6">Private Classes</h2>
                    <table className="w-full table-auto border-collapse text-sm">
                        <thead className="bg-gray-50 border-b">
                        <tr>
                            <th className="p-4">
                                <div className="flex items-center gap-1">#</div>
                            </th>
                            <th className="text-left px-4 py-2 font-medium text-gray-600">
                                <div className="flex items-center gap-1">Child</div>
                            </th>
                            <th className="text-left px-4 py-2 font-medium text-gray-600">
                                <div className="flex items-center gap-1">Class</div>
                            </th>
                            <th className="text-left px-4 py-2 font-medium text-gray-600">
                                <div className="flex items-center gap-1">Amount</div>
                            </th>
                            <th className="text-left px-4 py-2 font-medium text-gray-600">
                                <div className="flex items-center gap-1">Sessions</div>
                            </th>
                            <th className="text-left px-4 py-2 font-medium text-gray-600">
                                <div className="flex items-center gap-1">Action</div>
                            </th>
                        </tr>
                        </thead>
                        <tbody className="text-gray-700">
                            {privateSubscriptions?.map((row, index) => (
                                <tr
                                key={index}
                                className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                                >
                                    <td className="px-4 py-2">
                                        {++index}
                                    </td>
                                    <td className="px-4 py-2 font-semibold">
                                        {row.child_name}
                                    </td>
                                    <td className="px-4 py-2">
                                        {row.language} ({row.level})
                                    </td>
                                    <td className="px-4 py-2">
                                        {row.amount} {row.currency}
                                    </td>
                                    <td className="px-4 py-2">
                                        {row.no_of_sessions}
                                    </td>
                                    <td className="px-4 py-2">
                                        <button onClick={() => {setPaymentModalDetails({level_name: row.level, language_name: row.language, no_of_sessions: row.no_of_sessions, subscription_id: row.sub_id, tutor_avail: row.tutor_avail, sessions_array: row.sessions_array}); setShowScheduleModal(true)}} className='px-4 py-2 bg-[#000aff] rounded-[5px] text-white mr-2 cursor-pointer'>Schedule</button>
                                        <button className='px-4 py-2 bg-yellow rounded-[5px] text-dark'>Retake</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </>
                    )}
                </div>
            </main>
        </div>
    </div>
  );
}

export default SubscriptionsScreen;
